import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import { FaRegQuestionCircle } from "react-icons/fa";

const InfoHelpModal = ({
  ariaLabel = "Open help",
  title = "Help",
  children,
  modalMaxWidthClassName = "max-w-2xl",
  buttonClassName = "inline-flex h-7 w-7 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#181010]/20",
  iconClassName = "h-[17px] w-[17px]",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        aria-label={ariaLabel}
        className={buttonClassName}
      >
        <FaRegQuestionCircle className={iconClassName} />
      </button>

      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        contentLabel={title}
        ariaHideApp={false}
        className={`relative z-[70] w-full ${modalMaxWidthClassName} rounded-2xl border border-[#e7dada] bg-white p-6 shadow-xl`}
        overlayClassName="fixed inset-0 z-[65] flex items-center justify-center bg-black/35 p-4"
      >
        <div className="flex items-start justify-between gap-4">
          <h3 className="text-lg font-semibold text-[#181010]">{title}</h3>
          <button
            type="button"
            onClick={() => setIsOpen(false)}
            className="rounded-md px-2 py-1 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
            aria-label="Close help"
          >
            X
          </button>
        </div>

        <div className="mt-4 space-y-4 text-sm leading-6 text-gray-700">{children}</div>

        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={() => setIsOpen(false)}
            className="rounded-lg bg-[#181010] px-4 py-2 text-sm font-medium text-white hover:opacity-90"
          >
            Close
          </button>
        </div>
      </Modal>
    </>
  );
};

InfoHelpModal.propTypes = {
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  modalMaxWidthClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  iconClassName: PropTypes.string,
};

export default React.memo(InfoHelpModal);
